import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { DestroyOptions } from "pixi.js";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";

export class RIPTypeTrigger extends DisplayObject {
    private anim: Spine;

    constructor(config: IDisplayObject) {
        super(config);
        this.createInstance();
    }

    public override destroy(options?: DestroyOptions): void {
        super.destroy(options);
    }

    private createInstance() {
        this.anim = Spine.from({
            skeleton: "featureTriggerTextSkel",
            atlas: "featureTriggerTextAtlas"
        });
        this.anim.label = "featureTriggerText";
        this.addChild(this.anim);
        // this.pivot.set(1500, 1500);
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
    }

    public play(type: string, callback: () => void) {
        this.anim.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        this.anim.state.setAnimation(0, type + "_text_in", false);
        this.anim.state.addAnimation(0, type + "_text_loop", false, 0);
        this.anim.state.addAnimation(0, type + "_text_out", false, 0);
        const listener = {
            complete: (entry: any) => {
                if (entry.animation.name === type + "_text_out") {
                    this.anim.state.removeListener(listener);
                    callback();
                }
            }
        };
        this.anim.state.addListener(listener);
    }
}
